import { createAction } from "@reduxjs/toolkit"
import { FeedbackNotification } from "./reducer"

export const setErrors = createAction<string[]>("feedback/setErrors")
export const setNotification = createAction<FeedbackNotification>("feedback/setNotification")
